.icon {
  flex: none;
  margin-top: 2px;
}

.offer {
  align-self: flex-start;
  text-align: left;
}
